import React from 'react';
import { ExternalLink } from 'lucide-react';
import { pressMentions } from '../data/mockData';

const News = () => {
  return (
    <section id="news" className="py-20 bg-gradient-to-br from-amber-50 via-white to-pink-50" data-testid="news-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-800">
            Ambarsariya in <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 via-orange-500 to-pink-500">News</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-pink-500 mx-auto mt-4 rounded-full"></div>
          <p className="text-gray-600 mt-4 text-lg">Our authentic Amritsari flavours are making headlines</p>
        </div>

        {/* Press cards */}
        <div className="grid sm:grid-cols-2 gap-8">
          {pressMentions.map((press) => (
            <a
              key={press.id}
              href={press.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`news-link-${press.id}`}
              className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl border border-gray-100 hover:-translate-y-1 transition-all duration-300 flex flex-col"
            >
              <div className="h-20 flex items-center mb-5">
                <img
                  src={press.logo}
                  alt={`${press.name} logo`}
                  className={`object-contain ${press.id === 2 ? 'max-h-20 max-w-[360px]' : 'max-h-12 max-w-[180px]'}`}
                  data-testid={`news-logo-${press.id}`}
                />
              </div>
              <p className="text-gray-700 text-lg font-medium flex-1">{press.title}</p>
              <span className="mt-6 inline-flex items-center gap-2 text-orange-600 font-semibold group-hover:gap-3 transition-all">
                Read Article <ExternalLink className="w-4 h-4" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default News;
